/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessanalyticsinsights2Inputs */

const en_businessanalyticsinsights2 = /** @type {(inputs: Businessanalyticsinsights2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Analytics & Insights`)
};

const de_businessanalyticsinsights2 = /** @type {(inputs: Businessanalyticsinsights2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken`)
};

/**
* | output |
* | --- |
* | "Business Analytics & Insights" |
*
* @param {Businessanalyticsinsights2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessanalyticsinsights2 = /** @type {((inputs?: Businessanalyticsinsights2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessanalyticsinsights2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessanalyticsinsights2(inputs)
	return de_businessanalyticsinsights2(inputs)
});
export { businessanalyticsinsights2 as "businessAnalyticsInsights" }